// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Admin Notice Management Styles — Dark Data-Dashboard Theme ===== */

/* Stats Grid */
.admin-notice__stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.admin-notice__stat-card {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-lg);
  padding: 20px;
  transition: all 0.2s;
}

.admin-notice__stat-card:hover {
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.35);
  transform: translateY(-2px);
}

.admin-notice__stat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.admin-notice__stat-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
}

.admin-notice__stat-icon--total {
  background: rgba(167, 139, 250, 0.1);
  color: #a78bfa;
}

.admin-notice__stat-icon--update {
  background: var(--admin-info-bg);
  color: var(--admin-info);
}

.admin-notice__stat-icon--maintenance {
  background: var(--admin-warning-bg);
  color: var(--admin-warning);
}

.admin-notice__stat-icon--resolved {
  background: var(--admin-success-bg);
  color: var(--admin-success);
}

.admin-notice__stat-label {
  font-size: 12px;
  color: var(--admin-text-muted);
  margin-bottom: 8px;
}

.admin-notice__stat-value {
  font-size: 28px;
  font-weight: 700;
  color: var(--admin-text-bright);
}

/* Tabs */
.admin-notice__tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.admin-notice__tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  font-size: 13px;
  font-weight: 500;
  color: var(--admin-text-secondary);
  background: var(--admin-surface);
  cursor: pointer;
  transition: all 0.2s;
}

.admin-notice__tab:hover {
  background: var(--admin-surface-hover);
  border-color: var(--admin-text-dim);
  color: var(--admin-text-primary);
}

.admin-notice__tab--active {
  background: var(--admin-surface-hover);
  color: var(--admin-text-bright);
  border-color: #a78bfa;
}

.admin-notice__tab-badge {
  background: var(--admin-surface-hover);
  color: var(--admin-text-secondary);
  padding: 2px 10px;
  border-radius: var(--radius-full);
  font-size: 12px;
  font-weight: 600;
  min-width: 24px;
  text-align: center;
}

.admin-notice__tab--active .admin-notice__tab-badge {
  background: rgba(167, 139, 250, 0.2);
  color: #a78bfa;
}

/* Table Container */
.admin-notice__table-container {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.admin-notice__table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid var(--admin-border);
  background: var(--admin-bg);
  gap: 16px;
}

.admin-notice__table-title {
  font-size: 15px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--admin-text-bright);
  white-space: nowrap;
}

.admin-notice__table-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.admin-notice__search-input {
  width: 260px;
  padding: 8px 14px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  font-size: 13px;
  background: var(--admin-bg);
  color: var(--admin-text-primary);
  transition: all 0.2s;
}

.admin-notice__search-input:focus {
  outline: none;
  border-color: #a78bfa;
  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);
}

.admin-notice__search-input::placeholder {
  color: var(--admin-text-muted);
}

/* Bulk Actions Bar */
.admin-notice__bulk-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 24px;
  background: var(--admin-surface);
  border-bottom: 1px solid var(--admin-border);
  animation: noticeBarIn 0.2s ease;
}

@keyframes noticeBarIn {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
}

.admin-notice__bulk-count {
  font-size: 13px;
  font-weight: 600;
  color: #a78bfa;
  white-space: nowrap;
}

.admin-notice__bulk-select {
  padding: 6px 12px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  font-size: 12px;
  background: var(--admin-bg);
  color: var(--admin-text-primary);
  cursor: pointer;
}

.admin-notice__bulk-select:focus {
  outline: none;
  border-color: #a78bfa;
}

.admin-notice__bulk-btn {
  padding: 6px 14px;
  border: none;
  border-radius: var(--radius-md);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  background: #a78bfa;
  color: var(--admin-bg);
}

.admin-notice__bulk-btn:hover {
  background: #8b5cf6;
}

.admin-notice__bulk-btn--danger {
  background: #ef4444;
  color: white;
}

.admin-notice__bulk-btn--danger:hover {
  background: #dc2626;
}

.admin-notice__bulk-cancel {
  padding: 6px 14px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  background: var(--admin-bg);
  color: var(--admin-text-secondary);
  transition: all 0.2s;
}

.admin-notice__bulk-cancel:hover {
  background: var(--admin-surface-hover);
  color: var(--admin-text-primary);
}

/* Table */
.admin-notice__table-wrap {
  overflow-x: auto;
}

.admin-notice__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.admin-notice__table th {
  text-align: left;
  padding: 10px 16px;
  font-size: 11px;
  font-weight: 600;
  color: var(--admin-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  background: var(--admin-surface);
  border-bottom: 1px solid var(--admin-border);
  white-space: nowrap;
}

.admin-notice__table td {
  padding: 12px 16px;
  border-bottom: 1px solid var(--admin-border-light);
  vertical-align: middle;
  color: var(--admin-text-primary);
}

.admin-notice__table tbody tr {
  transition: background 0.15s;
}

.admin-notice__table tbody tr:hover {
  background: rgba(167, 139, 250, 0.05);
}

.admin-notice__table tbody tr:last-child td {
  border-bottom: none;
}

.admin-notice__table tbody tr.admin-notice__row--selected {
  background: rgba(167, 139, 250, 0.08);
}

/* Checkbox */
.admin-notice__checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #a78bfa;
}

/* Notice Title Cell */
.admin-notice__title-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: var(--admin-text-bright);
  font-size: 13px;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.admin-notice__pin-icon {
  color: #a78bfa;
  flex-shrink: 0;
}

/* Category Badge */
.admin-notice__category-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: var(--radius-full);
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.admin-notice__category-badge--update {
  background: var(--admin-info-bg);
  color: var(--admin-info);
}

.admin-notice__category-badge--maintenance {
  background: var(--admin-warning-bg);
  color: var(--admin-warning);
}

.admin-notice__category-badge--resolved {
  background: var(--admin-success-bg);
  color: var(--admin-success);
}

.admin-notice__category-badge--education {
  background: var(--fg-bg-liteblue, #e0f2fe);
  color: var(--fg-link, #0369a1);
}

.admin-notice__category-badge--seminar {
  background: var(--fg-bg-litepp, #f3e8ff);
  color: var(--fg-text-purple, #7c3aed);
}

/* Publish Toggle */
.admin-notice__toggle {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
}

.admin-notice__toggle-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.admin-notice__toggle-slider {
  width: 36px;
  height: 20px;
  background: var(--admin-border);
  border-radius: 10px;
  position: relative;
  transition: background 0.2s;
  flex-shrink: 0;
}

.admin-notice__toggle-slider::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background: white;
  border-radius: 50%;
  transition: transform 0.2s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.admin-notice__toggle-input:checked + .admin-notice__toggle-slider {
  background: #a78bfa;
}

.admin-notice__toggle-input:checked + .admin-notice__toggle-slider::after {
  transform: translateX(16px);
}

.admin-notice__toggle-label {
  font-size: 12px;
  color: var(--admin-text-secondary);
  font-weight: 500;
}

/* Action Buttons */
.admin-notice__action-group {
  display: flex;
  gap: 6px;
}

.admin-notice__action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  background: var(--admin-bg);
  color: var(--admin-text-secondary);
  cursor: pointer;
  transition: all 0.2s;
}

.admin-notice__action-btn:hover {
  background: var(--admin-surface-hover);
  border-color: #a78bfa;
  color: #a78bfa;
}

.admin-notice__action-btn--danger:hover {
  background: rgba(239, 68, 68, 0.1);
  border-color: #ef4444;
  color: #ef4444;
}

/* Modal */
.admin-notice__modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
}

.admin-notice__modal {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-xl);
  width: 100%;
  max-width: 1000px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.5);
  animation: noticeModalIn 0.2s ease;
  display: flex;
  flex-direction: column;
}

@keyframes noticeModalIn {
  from { opacity: 0; transform: translateY(16px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.admin-notice__modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid var(--admin-border);
  flex-shrink: 0;
}

.admin-notice__modal-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--admin-text-bright);
}

.admin-notice__modal-close {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-md);
  background: var(--admin-bg);
  border: 1px solid var(--admin-border);
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--admin-text-secondary);
  transition: all 0.2s;
}

.admin-notice__modal-close:hover {
  background: var(--admin-surface-hover);
  color: var(--admin-text-bright);
}

.admin-notice__modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1 1;
}

.admin-notice__modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid var(--admin-border);
  background: var(--admin-bg);
  flex-shrink: 0;
}

/* Form */
.admin-notice__form-group {
  margin-bottom: 20px;
}

.admin-notice__form-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--admin-text-primary);
}

.admin-notice__form-input {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  font-size: 14px;
  background: var(--admin-bg);
  color: var(--admin-text-primary);
  transition: all 0.2s;
  box-sizing: border-box;
}

.admin-notice__form-input:focus {
  outline: none;
  border-color: #a78bfa;
  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);
}

.admin-notice__form-input::placeholder {
  color: var(--admin-text-muted);
}

.admin-notice__form-textarea {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  font-size: 14px;
  font-family: inherit;
  background: var(--admin-bg);
  color: var(--admin-text-primary);
  transition: all 0.2s;
  box-sizing: border-box;
  resize: vertical;
  line-height: 1.5;
}

.admin-notice__form-textarea:focus {
  outline: none;
  border-color: #a78bfa;
  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);
}

.admin-notice__form-textarea::placeholder {
  color: var(--admin-text-muted);
}

.admin-notice__form-select {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  font-size: 14px;
  background: var(--admin-bg);
  color: var(--admin-text-primary);
  transition: all 0.2s;
  cursor: pointer;
}

.admin-notice__form-select:focus {
  outline: none;
  border-color: #a78bfa;
  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);
}

.admin-notice__form-row {
  display: flex;
  gap: 16px;
}

.admin-notice__form-row .admin-notice__form-group {
  flex: 1 1;
}

/* Quill Editor Overrides */
.admin-notice__editor .ql-toolbar.ql-snow {
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md) var(--radius-md) 0 0;
  background: var(--admin-bg);
  font-family: inherit;
  position: sticky;
  top: -24px;
  z-index: 10;
}

.admin-notice__editor .ql-container.ql-snow {
  border: 1px solid var(--admin-border);
  border-top: none;
  border-radius: 0 0 var(--radius-md) var(--radius-md);
  font-family: inherit;
  font-size: 14px;
  min-height: 200px;
  background: var(--admin-bg);
  color: var(--admin-text-primary);
}

.admin-notice__editor .ql-editor {
  min-height: 200px;
  line-height: 1.6;
  color: var(--admin-text-primary);
}

.admin-notice__editor .ql-editor.ql-blank::before {
  color: var(--admin-text-dim);
  font-style: normal;
}

.admin-notice__editor .ql-snow .ql-stroke {
  stroke: var(--admin-text-secondary);
}

.admin-notice__editor .ql-snow .ql-fill {
  fill: var(--admin-text-secondary);
}

.admin-notice__editor .ql-snow .ql-picker {
  color: var(--admin-text-secondary);
}

.admin-notice__editor .ql-snow .ql-picker-options {
  background: var(--admin-surface);
  border-color: var(--admin-border);
}

.admin-notice__editor .ql-snow .ql-picker-label:hover {
  color: var(--admin-text-primary);
}

.admin-notice__editor .ql-snow .ql-active .ql-stroke {
  stroke: #a78bfa;
}

.admin-notice__editor .ql-snow .ql-active .ql-fill {
  fill: #a78bfa;
}

.admin-notice__editor .ql-snow .ql-active {
  color: #a78bfa;
}

/* Toggle Row */
.admin-notice__form-toggles-row {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
}

.admin-notice__form-toggles-row .admin-notice__form-toggle {
  flex: 1 1;
}

/* Publish Toggle in Form */
.admin-notice__form-toggle {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: var(--admin-bg);
  border-radius: var(--radius-md);
  border: 1px solid var(--admin-border);
}

.admin-notice__form-toggle-info {
  flex: 1 1;
}

.admin-notice__form-toggle-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--admin-text-primary);
}

.admin-notice__form-toggle-desc {
  font-size: 12px;
  color: var(--admin-text-muted);
  margin-top: 2px;
}

/* Empty State */
.admin-notice__empty-state {
  text-align: center;
  padding: 60px 20px;
}

.admin-notice__empty-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  color: var(--admin-text-muted);
  stroke-width: 1.5;
  stroke: currentColor;
  fill: none;
}

.admin-notice__empty-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--admin-text-secondary);
  margin-bottom: 8px;
}

.admin-notice__empty-desc {
  font-size: 13px;
  color: var(--admin-text-muted);
}

/* Pagination */
.admin-notice__pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  border-top: 1px solid var(--admin-border);
  background: var(--admin-bg);
}

.admin-notice__pagination-info {
  font-size: 12px;
  color: var(--admin-text-muted);
}

.admin-notice__pagination-buttons {
  display: flex;
  gap: 4px;
}

.admin-notice__pagination-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  background: var(--admin-surface);
  color: var(--admin-text-secondary);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.admin-notice__pagination-btn:hover {
  background: var(--admin-surface-hover);
  border-color: #a78bfa;
  color: #a78bfa;
}

.admin-notice__pagination-btn--active {
  background: var(--admin-surface-hover);
  border-color: #a78bfa;
  color: var(--admin-text-bright);
}

.admin-notice__pagination-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Date text */
.admin-notice__date {
  font-size: 12px;
  color: var(--admin-text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/css/AdminNoticeManagement.css"],"names":[],"mappings":"AAAA,2EAA2E;;AAE3E,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;AAChC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;EAClC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,kCAAkC;EAClC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,2BAA2B;EAC3B,qCAAqC;EACrC,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,2BAA2B;EAC3B,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;EAChC,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,2BAA2B;EAC3B,gCAAgC;EAChC,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA,2BAA2B;AAC3B;EACE,qCAAqC;EACrC,oDAAoD;EACpD,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,oDAAoD;EACpD,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,+BAA+B;EAC/B,gCAAgC;EAChC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,kCAAkC;AACpC","sourcesContent":["/* ===== Admin Notice Management Styles — Dark Data-Dashboard Theme ===== */\n\n/* Stats Grid */\n.admin-notice__stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.admin-notice__stat-card {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-lg);\n  padding: 20px;\n  transition: all 0.2s;\n}\n\n.admin-notice__stat-card:hover {\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.35);\n  transform: translateY(-2px);\n}\n\n.admin-notice__stat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.admin-notice__stat-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.admin-notice__stat-icon--total {\n  background: rgba(167, 139, 250, 0.1);\n  color: #a78bfa;\n}\n\n.admin-notice__stat-icon--update {\n  background: var(--admin-info-bg);\n  color: var(--admin-info);\n}\n\n.admin-notice__stat-icon--maintenance {\n  background: var(--admin-warning-bg);\n  color: var(--admin-warning);\n}\n\n.admin-notice__stat-icon--resolved {\n  background: var(--admin-success-bg);\n  color: var(--admin-success);\n}\n\n.admin-notice__stat-label {\n  font-size: 12px;\n  color: var(--admin-text-muted);\n  margin-bottom: 8px;\n}\n\n.admin-notice__stat-value {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--admin-text-bright);\n}\n\n/* Tabs */\n.admin-notice__tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n}\n\n.admin-notice__tab {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n  background: var(--admin-surface);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.admin-notice__tab:hover {\n  background: var(--admin-surface-hover);\n  border-color: var(--admin-text-dim);\n  color: var(--admin-text-primary);\n}\n\n.admin-notice__tab--active {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-bright);\n  border-color: #a78bfa;\n}\n\n.admin-notice__tab-badge {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-secondary);\n  padding: 2px 10px;\n  border-radius: var(--radius-full);\n  font-size: 12px;\n  font-weight: 600;\n  min-width: 24px;\n  text-align: center;\n}\n\n.admin-notice__tab--active .admin-notice__tab-badge {\n  background: rgba(167, 139, 250, 0.2);\n  color: #a78bfa;\n}\n\n/* Table Container */\n.admin-notice__table-container {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n\n.admin-notice__table-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  border-bottom: 1px solid var(--admin-border);\n  background: var(--admin-bg);\n  gap: 16px;\n}\n\n.admin-notice__table-title {\n  font-size: 15px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--admin-text-bright);\n  white-space: nowrap;\n}\n\n.admin-notice__table-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.admin-notice__search-input {\n  width: 260px;\n  padding: 8px 14px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  font-size: 13px;\n  background: var(--admin-bg);\n  color: var(--admin-text-primary);\n  transition: all 0.2s;\n}\n\n.admin-notice__search-input:focus {\n  outline: none;\n  border-color: #a78bfa;\n  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);\n}\n\n.admin-notice__search-input::placeholder {\n  color: var(--admin-text-muted);\n}\n\n/* Bulk Actions Bar */\n.admin-notice__bulk-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 24px;\n  background: var(--admin-surface);\n  border-bottom: 1px solid var(--admin-border);\n  animation: noticeBarIn 0.2s ease;\n}\n\n@keyframes noticeBarIn {\n  from { opacity: 0; transform: translateY(-4px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.admin-notice__bulk-count {\n  font-size: 13px;\n  font-weight: 600;\n  color: #a78bfa;\n  white-space: nowrap;\n}\n\n.admin-notice__bulk-select {\n  padding: 6px 12px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  font-size: 12px;\n  background: var(--admin-bg);\n  color: var(--admin-text-primary);\n  cursor: pointer;\n}\n\n.admin-notice__bulk-select:focus {\n  outline: none;\n  border-color: #a78bfa;\n}\n\n.admin-notice__bulk-btn {\n  padding: 6px 14px;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  background: #a78bfa;\n  color: var(--admin-bg);\n}\n\n.admin-notice__bulk-btn:hover {\n  background: #8b5cf6;\n}\n\n.admin-notice__bulk-btn--danger {\n  background: #ef4444;\n  color: white;\n}\n\n.admin-notice__bulk-btn--danger:hover {\n  background: #dc2626;\n}\n\n.admin-notice__bulk-cancel {\n  padding: 6px 14px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  background: var(--admin-bg);\n  color: var(--admin-text-secondary);\n  transition: all 0.2s;\n}\n\n.admin-notice__bulk-cancel:hover {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-primary);\n}\n\n/* Table */\n.admin-notice__table-wrap {\n  overflow-x: auto;\n}\n\n.admin-notice__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.admin-notice__table th {\n  text-align: left;\n  padding: 10px 16px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--admin-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  background: var(--admin-surface);\n  border-bottom: 1px solid var(--admin-border);\n  white-space: nowrap;\n}\n\n.admin-notice__table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--admin-border-light);\n  vertical-align: middle;\n  color: var(--admin-text-primary);\n}\n\n.admin-notice__table tbody tr {\n  transition: background 0.15s;\n}\n\n.admin-notice__table tbody tr:hover {\n  background: rgba(167, 139, 250, 0.05);\n}\n\n.admin-notice__table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.admin-notice__table tbody tr.admin-notice__row--selected {\n  background: rgba(167, 139, 250, 0.08);\n}\n\n/* Checkbox */\n.admin-notice__checkbox {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: #a78bfa;\n}\n\n/* Notice Title Cell */\n.admin-notice__title-cell {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 600;\n  color: var(--admin-text-bright);\n  font-size: 13px;\n  max-width: 300px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.admin-notice__pin-icon {\n  color: #a78bfa;\n  flex-shrink: 0;\n}\n\n/* Category Badge */\n.admin-notice__category-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border-radius: var(--radius-full);\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.admin-notice__category-badge--update {\n  background: var(--admin-info-bg);\n  color: var(--admin-info);\n}\n\n.admin-notice__category-badge--maintenance {\n  background: var(--admin-warning-bg);\n  color: var(--admin-warning);\n}\n\n.admin-notice__category-badge--resolved {\n  background: var(--admin-success-bg);\n  color: var(--admin-success);\n}\n\n.admin-notice__category-badge--education {\n  background: var(--fg-bg-liteblue, #e0f2fe);\n  color: var(--fg-link, #0369a1);\n}\n\n.admin-notice__category-badge--seminar {\n  background: var(--fg-bg-litepp, #f3e8ff);\n  color: var(--fg-text-purple, #7c3aed);\n}\n\n/* Publish Toggle */\n.admin-notice__toggle {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  gap: 8px;\n}\n\n.admin-notice__toggle-input {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.admin-notice__toggle-slider {\n  width: 36px;\n  height: 20px;\n  background: var(--admin-border);\n  border-radius: 10px;\n  position: relative;\n  transition: background 0.2s;\n  flex-shrink: 0;\n}\n\n.admin-notice__toggle-slider::after {\n  content: '';\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 16px;\n  height: 16px;\n  background: white;\n  border-radius: 50%;\n  transition: transform 0.2s;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.admin-notice__toggle-input:checked + .admin-notice__toggle-slider {\n  background: #a78bfa;\n}\n\n.admin-notice__toggle-input:checked + .admin-notice__toggle-slider::after {\n  transform: translateX(16px);\n}\n\n.admin-notice__toggle-label {\n  font-size: 12px;\n  color: var(--admin-text-secondary);\n  font-weight: 500;\n}\n\n/* Action Buttons */\n.admin-notice__action-group {\n  display: flex;\n  gap: 6px;\n}\n\n.admin-notice__action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  background: var(--admin-bg);\n  color: var(--admin-text-secondary);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.admin-notice__action-btn:hover {\n  background: var(--admin-surface-hover);\n  border-color: #a78bfa;\n  color: #a78bfa;\n}\n\n.admin-notice__action-btn--danger:hover {\n  background: rgba(239, 68, 68, 0.1);\n  border-color: #ef4444;\n  color: #ef4444;\n}\n\n/* Modal */\n.admin-notice__modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(4px);\n}\n\n.admin-notice__modal {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-xl);\n  width: 100%;\n  max-width: 1000px;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.5);\n  animation: noticeModalIn 0.2s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n@keyframes noticeModalIn {\n  from { opacity: 0; transform: translateY(16px) scale(0.98); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n.admin-notice__modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--admin-border);\n  flex-shrink: 0;\n}\n\n.admin-notice__modal-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--admin-text-bright);\n}\n\n.admin-notice__modal-close {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-md);\n  background: var(--admin-bg);\n  border: 1px solid var(--admin-border);\n  font-size: 20px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--admin-text-secondary);\n  transition: all 0.2s;\n}\n\n.admin-notice__modal-close:hover {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-bright);\n}\n\n.admin-notice__modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.admin-notice__modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid var(--admin-border);\n  background: var(--admin-bg);\n  flex-shrink: 0;\n}\n\n/* Form */\n.admin-notice__form-group {\n  margin-bottom: 20px;\n}\n\n.admin-notice__form-label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: var(--admin-text-primary);\n}\n\n.admin-notice__form-input {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  font-size: 14px;\n  background: var(--admin-bg);\n  color: var(--admin-text-primary);\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n.admin-notice__form-input:focus {\n  outline: none;\n  border-color: #a78bfa;\n  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);\n}\n\n.admin-notice__form-input::placeholder {\n  color: var(--admin-text-muted);\n}\n\n.admin-notice__form-textarea {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  font-size: 14px;\n  font-family: inherit;\n  background: var(--admin-bg);\n  color: var(--admin-text-primary);\n  transition: all 0.2s;\n  box-sizing: border-box;\n  resize: vertical;\n  line-height: 1.5;\n}\n\n.admin-notice__form-textarea:focus {\n  outline: none;\n  border-color: #a78bfa;\n  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);\n}\n\n.admin-notice__form-textarea::placeholder {\n  color: var(--admin-text-muted);\n}\n\n.admin-notice__form-select {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  font-size: 14px;\n  background: var(--admin-bg);\n  color: var(--admin-text-primary);\n  transition: all 0.2s;\n  cursor: pointer;\n}\n\n.admin-notice__form-select:focus {\n  outline: none;\n  border-color: #a78bfa;\n  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);\n}\n\n.admin-notice__form-row {\n  display: flex;\n  gap: 16px;\n}\n\n.admin-notice__form-row .admin-notice__form-group {\n  flex: 1;\n}\n\n/* Quill Editor Overrides */\n.admin-notice__editor .ql-toolbar.ql-snow {\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md) var(--radius-md) 0 0;\n  background: var(--admin-bg);\n  font-family: inherit;\n  position: sticky;\n  top: -24px;\n  z-index: 10;\n}\n\n.admin-notice__editor .ql-container.ql-snow {\n  border: 1px solid var(--admin-border);\n  border-top: none;\n  border-radius: 0 0 var(--radius-md) var(--radius-md);\n  font-family: inherit;\n  font-size: 14px;\n  min-height: 200px;\n  background: var(--admin-bg);\n  color: var(--admin-text-primary);\n}\n\n.admin-notice__editor .ql-editor {\n  min-height: 200px;\n  line-height: 1.6;\n  color: var(--admin-text-primary);\n}\n\n.admin-notice__editor .ql-editor.ql-blank::before {\n  color: var(--admin-text-dim);\n  font-style: normal;\n}\n\n.admin-notice__editor .ql-snow .ql-stroke {\n  stroke: var(--admin-text-secondary);\n}\n\n.admin-notice__editor .ql-snow .ql-fill {\n  fill: var(--admin-text-secondary);\n}\n\n.admin-notice__editor .ql-snow .ql-picker {\n  color: var(--admin-text-secondary);\n}\n\n.admin-notice__editor .ql-snow .ql-picker-options {\n  background: var(--admin-surface);\n  border-color: var(--admin-border);\n}\n\n.admin-notice__editor .ql-snow .ql-picker-label:hover {\n  color: var(--admin-text-primary);\n}\n\n.admin-notice__editor .ql-snow .ql-active .ql-stroke {\n  stroke: #a78bfa;\n}\n\n.admin-notice__editor .ql-snow .ql-active .ql-fill {\n  fill: #a78bfa;\n}\n\n.admin-notice__editor .ql-snow .ql-active {\n  color: #a78bfa;\n}\n\n/* Toggle Row */\n.admin-notice__form-toggles-row {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.admin-notice__form-toggles-row .admin-notice__form-toggle {\n  flex: 1;\n}\n\n/* Publish Toggle in Form */\n.admin-notice__form-toggle {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: var(--admin-bg);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--admin-border);\n}\n\n.admin-notice__form-toggle-info {\n  flex: 1;\n}\n\n.admin-notice__form-toggle-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n}\n\n.admin-notice__form-toggle-desc {\n  font-size: 12px;\n  color: var(--admin-text-muted);\n  margin-top: 2px;\n}\n\n/* Empty State */\n.admin-notice__empty-state {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.admin-notice__empty-icon {\n  width: 64px;\n  height: 64px;\n  margin: 0 auto 16px;\n  color: var(--admin-text-muted);\n  stroke-width: 1.5;\n  stroke: currentColor;\n  fill: none;\n}\n\n.admin-notice__empty-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--admin-text-secondary);\n  margin-bottom: 8px;\n}\n\n.admin-notice__empty-desc {\n  font-size: 13px;\n  color: var(--admin-text-muted);\n}\n\n/* Pagination */\n.admin-notice__pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 24px;\n  border-top: 1px solid var(--admin-border);\n  background: var(--admin-bg);\n}\n\n.admin-notice__pagination-info {\n  font-size: 12px;\n  color: var(--admin-text-muted);\n}\n\n.admin-notice__pagination-buttons {\n  display: flex;\n  gap: 4px;\n}\n\n.admin-notice__pagination-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 32px;\n  height: 32px;\n  padding: 0 8px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  background: var(--admin-surface);\n  color: var(--admin-text-secondary);\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.admin-notice__pagination-btn:hover {\n  background: var(--admin-surface-hover);\n  border-color: #a78bfa;\n  color: #a78bfa;\n}\n\n.admin-notice__pagination-btn--active {\n  background: var(--admin-surface-hover);\n  border-color: #a78bfa;\n  color: var(--admin-text-bright);\n}\n\n.admin-notice__pagination-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* Date text */\n.admin-notice__date {\n  font-size: 12px;\n  color: var(--admin-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
